export default "__VITE_ASSET__a6e13c83__"